var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5187 5.01545C4.5187 2.26403 6.74917 0.0335693 9.50059 0.0335693C12.252 0.0335693 14.4825 2.26403 14.4825 5.01545C14.4825 6.90423 13.4314 8.5475 11.8822 9.39226C15.8416 10.4133 18.8022 13.9201 19.0005 18.1493H18.0936C17.858 13.6075 14.1011 9.99734 9.50059 9.99734C4.90011 9.99734 1.14252 13.6075 0.906918 18.1493H0C0.198351 13.92 3.15914 10.413 7.11876 9.39215C5.5697 8.54736 4.5187 6.90414 4.5187 5.01545ZM9.51855 9.03357C11.7277 9.03357 13.5186 7.24271 13.5186 5.03357C13.5186 2.82443 11.7277 1.03357 9.51855 1.03357C7.30942 1.03357 5.51855 2.82443 5.51855 5.03357C5.51855 7.24271 7.30942 9.03357 9.51855 9.03357Z",
    fill: "current"
  })));
};
export default __webpack_public_path__ + "static/media/my_page.2509d8d5.svg";
export { SvgComponent as ReactComponent };